import axios from 'axios';
import type { AddFirefighter } from '../types';

const BACKEND_URL = process.env.REACT_APP_API_URL;

axios.defaults.baseURL = BACKEND_URL;
axios.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
};

type Response = {
  error: boolean;
  message?: unknown;
  data?: unknown;
};

const getToken = (): string | undefined => {
  const tokenString = sessionStorage.getItem('token');
  const token = tokenString !== null ? atob(tokenString) : undefined;

  return token;
};

export class FirefighterService {
  static async getAllFirefightersOfDepartment(departmentId: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .get(`/v1/firefighter/department/${departmentId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async getFirefighterById(firefighterId: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .get(`/v1/firefighter/${firefighterId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async addFirefighter(firefighter: AddFirefighter): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .post(
          '/v1/firefighter',
          { ...firefighter },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }
}
